import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad innebär ett cateringtillstånd?";
const SHORT_ANSWER = "Cateringtillstånd ger ett företag rätt att servera alkohol i lokaler det inte själv förfogar över – till exempel företagsfester på externa platser.";

export const Route = createFileRoute("/fraga/cateringtillstand-vad-innebar-det")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad innebär ett cateringtillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Varje serveringstillfälle ska anmälas till kommunen i förväg, normalt minst 1–2 veckor innan. Lokalen ska vara lämplig och prövas av kommunen vid anmälan. Cateringtillstånd kräver lika omfattande lämplighetsprövning som stadigvarande tillstånd."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/serveringstillstand-catering-guide", label: "Cateringtillstånd – komplett guide" }}
      related={[{"to": "/fraga/kan-jag-anvanda-pausservering", "label": "Vad är pausservering och vem kan få det?"}, {"to": "/fraga/vad-ar-gemensam-serveringsyta", "label": "Vad är en gemensam serveringsyta?"}, {"to": "/fraga/skillnad-stadigvarande-tillfalligt", "label": "Vad är skillnaden mellan stadigvarande och tillfälligt tillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad innebär ett cateringtillstånd?" },
      { name: "description", content: "Cateringtillstånd ger ett företag rätt att servera alkohol i lokaler det inte själv förfogar över – till exempel företagsfester på externa platser." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/cateringtillstand-vad-innebar-det" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/cateringtillstand-vad-innebar-det" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/cateringtillstand-vad-innebar-det",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad innebär ett cateringtillstånd", url: "https://alkoholprovet.se/fraga/cateringtillstand-vad-innebar-det" },
      ]),
    ],
  }),
});
